import { useMemo } from "react";

export default function useClassesFilters({
  classlists,
  selectedCampus,
  selectedAge,
  selectedEnglishLevel,
  selectedClass,
  nameSearch,
  sortField,
  sortAsc,
}) {
  const filteredClasslists = useMemo(() => {
    let filtered = [...classlists];

    if (selectedCampus) {
      filtered = filtered.filter((s) => s.campus === selectedCampus);
    }

    if (selectedAge) {
      filtered = filtered.filter(
        (s) => s.student_age === parseInt(selectedAge, 10)
      );
    }

    if (selectedEnglishLevel) {
      filtered = filtered.filter(
        (s) => s.english_level === selectedEnglishLevel
      );
    }

    if (selectedClass) {
      filtered = filtered.filter(
        (s) => (s.group_name || "None") === selectedClass
      );
    }

    if (nameSearch.trim() !== "") {
      const query = nameSearch.toLowerCase();
      filtered = filtered.filter((s) =>
        `${s.student_name} ${s.student_surname}`
          .toLowerCase()
          .includes(query)
      );
    }

    return filtered;
  }, [
    classlists,
    selectedCampus,
    selectedAge,
    selectedEnglishLevel,
    selectedClass,
    nameSearch,
  ]);

  const sortedClasslists = useMemo(() => {
    const rows = [...filteredClasslists];

    if (!sortField) return rows;

    rows.sort((a, b) => {
      const valA = a?.[sortField];
      const valB = b?.[sortField];

      if (valA == null && valB == null) return 0;
      if (valA == null) return sortAsc ? -1 : 1;
      if (valB == null) return sortAsc ? 1 : -1;

      if (valA < valB) return sortAsc ? -1 : 1;
      if (valA > valB) return sortAsc ? 1 : -1;
      return 0;
    });

    return rows;
  }, [filteredClasslists, sortField, sortAsc]);

  const ageOptions = useMemo(
    () =>
      [...new Set(classlists.map((s) => s.student_age).filter(Boolean))].sort(
        (a, b) => a - b
      ),
    [classlists]
  );

  const levelOptions = useMemo(
    () =>
      [...new Set(classlists.map((s) => s.english_level).filter(Boolean))].sort(),
    [classlists]
  );

  const classOptions = useMemo(
    () =>
      [...new Set(classlists.map((s) => s.group_name || "None"))].sort(),
    [classlists]
  );

  return {
    filteredClasslists,
    sortedClasslists,
    ageOptions,
    levelOptions,
    classOptions,
  };
}